import { QUIZ } from "@/theme/quizTokens";
export const PACK_SIZES = [250, 400, 600, 800] as const;
export const PLAN_DAYS = [7, 14, 28] as const;

export const COLORS = {
  brown: QUIZ.color.brown,
  brownDark: "#5A2504",
  brownDeep: QUIZ.color.brown,
  coral: QUIZ.color.brown,
  coralDark: "#E96A67",
  cream: QUIZ.color.cream,
  red: "#D14C3F",
  redLight: "#FFE5E2",
  redLighter: "#FFEBEE",
  redBorder: "#FFCDD2",
  green: "#2E7D32",
  greenLight: "#E5FFEA",
  greenDark: "#1E6620",
  orange: "#CE7A00",
  orangeLight: "#FFF0D6",
  orangeText: "#E65100",
  orangeBg: "#FFF3E0",
  blue: "#1565C0",
  blueDark: "#0D47A1",
  blueLight: "#E3F2FD",
  borderLight: "#E5D9C9",
  textMuted: "#666",
  textLight: "#999",
} as const;
